import React from 'react';
import '../../style/chart_container.scss';
import '../../style/chart.scss';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { LazyReactChart } from '../../LazyReactChart';

type Props = {
  sectorsData: Array<number> | null;
  sectorsLabels: Array<string> | null;
};

export class CompanySectorTypologiesChart extends React.Component<Props> {
  sectorsBaseH = 278;

  render() {
    const { sectorsData, sectorsLabels } = this.props;
    return (
      <div className="chart-container">
        <div className="chart">
          {sectorsData && sectorsLabels && (
            <LazyReactChart
              config={getPercentPieChartConfig({
                data: sectorsData,
                labels: sectorsLabels,
                baseH: this.sectorsBaseH,
              })}
            />
          )}
        </div>
        {sectorsData && sectorsLabels && (
          <ChartPercentLegend
            data={sectorsData}
            labels={sectorsLabels}
            baseH={this.sectorsBaseH}
          />
        )}
      </div>
    );
  }
}
